<template>
  <l-geo-json
    :visible="mapRegionsWithGeoData && $store.state.mode === 'otachange'"
    :geojson="mapRegionsWithGeoData"
    :options="mapRegionsOptionsOtaChange"
  ></l-geo-json>
</template>
<script lang="js">
import Vue from 'vue';
import {LGeoJson} from 'vue2-leaflet';
import {
  onEachFeature,
  mouseOverRegion,
  mouseOutRegion,
  redrawMap,
  generateTooltip,
  calculateStyle,
  isOtaRegionStyle,
  regionIsNewSelectedOtaRegion,
  regionIsOldOtaRegion,
  isUserSelectedOtaRegionOutdated,
} from './methods.js'

export default Vue.extend({
  name: 'nmouc-map-ota-change',
  props: {
    mapRegionsWithGeoData: {
      type: Object,
      required: true,
    }
  },
  components: {
    LGeoJson,
  },
  data() {
    return {
      mapRegionsOptionsOtaChange: {
        style: {
          pane: 'mapRegionsPane'
        },
        onEachFeature: this.onEachFeature
      },
    };
  },
  methods: {
    onEachFeature,
    mouseOverRegion,
    mouseOutRegion,
    redrawMap,
    generateTooltip,
    calculateStyle,
    isOtaRegionStyle,
    regionIsNewSelectedOtaRegion,
    regionIsOldOtaRegion,
    isUserSelectedOtaRegionOutdated,
    clickedFeature(e) {
      this.$store.commit('setOtaChangeSelectedRegion', e.target.feature.properties.mapInfos)
      this.redrawMap();
    },
  }
});
</script>
<style lang="scss">
.warning-icon {
  width: 18px;
  height: 18px;
  margin-right: 0px;
  margin-bottom: 0px;
  padding-bottom: 3px;
}
</style>
